/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import {
  type FieldError,
  type FieldErrors,
  type UseFormRegister,
} from "react-hook-form";
import * as Styles from "./textInput.styles";

interface InputZodProps {
  property: string;
  register: UseFormRegister<any>;
  type?: "text" | "email" | "password" | "number";
  errors?: FieldErrors | undefined;
  showErrors?: boolean;
  isError?: boolean;
  placeholder?: string;
  align?: "left" | "center" | "right";
  disabled?: boolean;
}

const TextInputZod: React.FC<InputZodProps> = ({
  property,
  register,
  type,
  errors,
  showErrors,
  isError,
  placeholder,
  align,
  disabled,
}) => {
  const errored = isError ?? !!errors?.[property];

  return (
    <Styles.Container>
      <Styles.InputContainer
        borderColor={errored ? "red" : "#C4C4C4"}
        disabled={disabled}
      >
        <Styles.Input
          placeholder={placeholder}
          {...register(property)}
          style={{ textAlign: align ?? "left" }}
          type={type ?? "text"}
          disabled={disabled}
        />
      </Styles.InputContainer>
      {errors && showErrors && (
        <p className="error-text">
          {errors[property] && (errors[property] as FieldError)?.message}
        </p>
      )}
    </Styles.Container>
  );
};

export default TextInputZod;
